window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.swatchSelector = options.swatchSelector;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );

    $(document).on('change', this.swatchSelector, function() {
      var elId = this.getAttribute('data-optionSelectorId'),
      el = document.getElementById(elId);
      el.value=this.value;
      el.dispatchEvent(new Event('change'));
    });

    $(this.singleOptionSelector, this.$container).on(
      'load',
      this._swatchOption(this.currentVariant)
    );

  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._swatchOption(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },

    /**
     * Clolor swatch option
     *
     * @param  {variant} variant - Currently selected variant
     */
    _swatchOption: function(variant) {
      if (variant) {
        //this._onSwatchChange();
        var cls = '.variant-swatch-'+ variant.id;
        var form = jQuery(this.singleOptionSelector).closest('form');
        //console.log(this.singleOptionSelector);
        for (var i=0,length=variant.options.length; i<length; i++) {
          if(variant.available) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] input[value="' + variant.options[i] +'"]');
            if (radioButton.size()) {
              radioButton.get(0).checked = true;
            }
          } else {
            $('.swatch[data-option-index="' + i + '"] .' + variant.options[i].toLowerCase() ).removeClass('available').addClass('soldout').find(':radio').attr('disabled');
          }
        }
      }
    }

  });

  return Variants;
})();



/*================ Sections ================*/
window.theme = window.theme || {};
theme.HeaderSection = (function(container) {
  function Header() {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)'
    }

    this._initBreakpoints();
    this._wishlistClr();
    this._announcement();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {},
        unmatch: function() {}
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {},
        unmatch: function() {}
      });
    },

    _announcement: function() {

      $(".announcement-bar").removeClass("hide");
      $(document).on('click', '.close-bar-btn', function(){
        $(".announcement-bar").addClass("hide");
        sessionStorage.setItem("closeBar", "true");
        $("body").removeClass("notify-bar");
        $('.site-header').css('top', 0);
        $('.site-header').trigger('detach.ScrollToFixed');
        $('.site-header').scrollToFixed();
      });
      if(sessionStorage.getItem("closeBar")){
        $(".announcement-bar").addClass("hide");
      }else{
        $(".announcement-bar").removeClass("hide");
        $("body").addClass("notify-bar");
      }
    },

    _wishlistClr: function() {
      var self = this,
      sb = document.querySelectorAll('.swym-button');
      dbg = 0;
      setTimeout(function() {
        sb&&$.each(sb, function(i,t){
          if(t.classList.contains('swym-loaded')) {
            dbg = 1;
          } else {
          }
        });
        if (dbg != 1) {
        } else {
          self._wishlistDarkBgClr();
        }
      }, 1000);
    },

    _wishlistDarkBgClr: function() {
      setTimeout(function() {
        var sb = document.querySelectorAll('.swym-button'),
        wln = document.querySelectorAll('.wl-nav'),
        dbg = false;
        sb&&$.each(sb, function(i,t){
          if(t.classList.contains('swym-added')) {
            dbg = true;
          }
        });
        if(dbg) {
          wln&&$.each(wln, function(i,t){
            t.classList.add('dark');
          });
        }
      }, 1000);
    },

    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

window.theme = window.theme || {};
theme.Custom = {
  drawertoggle: function(cls) {
    var at = 'data-target', val = 'o-'+cls.replace(/[.\.]+/g, ""),
    ov = document.querySelector('.overlay'),
    el = document.querySelectorAll(cls);
    if (ov.classList.contains('active') && ov.getAttribute(at) != val) {
      ov.click();
    }
    el&&$.each(el,function(i,t){
      t.classList.toggle('active');
    })
    document.querySelector('body').classList.toggle('drawer-open');
    ov.classList.toggle('active');
    if (ov.classList.contains('active')) {
      ov.classList.add(val);
      ov.setAttribute(at, val);
    } else {
      ov.classList.remove(val);
      ov.setAttribute(at, '');
    }
    return 1;
  },
  clstoggle: function(sel, cls) {
    return document.querySelector(sel).classList.toggle(cls);
  }
};



/**
 *Wholesale Page Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.WholesalePage = (function() {
  function WholesalePage(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      swatch: true
    };

    this._owlCarousel();
 
  }

  WholesalePage.prototype = _.assignIn({}, WholesalePage.prototype, {

    _owlCarousel: function(){
      $('.item').addClass('slide-block');
      if($(".data-slick-slider").length){
        options = {
            dots: false,
            nav: true,
            items: 1,
            loop: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1
                },
                680: {
                    items: 1
                },
                1024: {
                    items: 1
                }
            }
        };
        setTimeout(function(el) {
          $(el).owlCarousel(options);
        }, 1000, ".data-slick-slider");

      }else{
        setTimeout(this._owlCarousel,200);
      }

      if($(".mobile-slider").length){
        options1 = {
            dots: false,
            nav: true,
            loop: true,
            items: 1
        };
        setTimeout(function(el) {
          $(el).owlCarousel(options1);
        }, 1000, ".mobile-slider");

      }else{
        setTimeout(this._owlCarousel,200);
      }

    },

  });

    var ctrlVideo = document.getElementById("video"); 
      $('.play-button').click(function(){
      if ($('.play-button').hasClass("active")){
      ctrlVideo.play();
      $('.play-button').html("");
      $('.play-button').toggleClass("active");
      }
    });
  

  return WholesalePage;
})();


/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      swatch: true
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      errorQuantityMessage: '#error-quantity-' + sectionId,
      quantity: '#Quantity-' + sectionId,
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      swatchSelector: '.swatch :radio',
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productFeaturedImage: '.product-featured-img',
      productSlider: '.product-slider',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]'
    };

    this.classes = {
      hidden: 'hide',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable',
      activeClass: 'active-thumb'
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    //this._initSexySelect();
    this._initImageSwitch();
    this._videoPlyr();
    this._initAddToCart();
    this._setActiveThumbnail();
    this._owlCarousel();
    //this._setColorName();
    this._toggleDesc();
    this._zoomImage();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {

      if ($(window).width() <= 991 && $(window).width() >= 768) {
        $("#description").removeClass("active");
        $(".nav-pills a").removeClass("active");
        $(".nav-pills .nav-item .nav-link").click(function(){
            if($(".pd-row-block .tab-content .tab-pane").hasClass("active")){
              $(".pd-row-block .tab-content .tab-pane").removeClass("active");
            }else{
              $($(this).attr("href")).addClass("active");
            }
        });
      }
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          self._initProductSlider();
          //self._smartPhotoPopup();
          //self._ymalProductsSlider();
        },
        unmatch: function() {
          self._destroyProductSlider();
          // if (self.settings.sliderActive) {
          //   self._destroyThumbnailSlider();
          // }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        unmatch: function() {
          //self._destroyYmalProductsSlider();
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        swatchSelector: this.selectors.swatchSelector,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initSexySelect: function() {
      $(this.selectors.singleOptionSelector).prettyDropdown({
        classic: true,
        selectedMarker: ''
      });
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data('thumbnail-id');

          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      var self = this;
      var $quantityInput = $(self.selectors.quantity);

      if ($quantityInput.length === 0) return;

      $(self.selectors.addToCart).on('click', function(evt) {
        var isInvalidQuantity = $quantityInput.val() <= 0;

        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        );

        if (isInvalidQuantity) {
          $quantityInput
            .attr(
              'aria-describedby',
              'error-quantity-' + self.settings.sectionId
            )
            .attr('aria-invalid', true);
          $(self.selectors.errorQuantityMessage).focus();
          evt.preventDefault();
        } else {
          $quantityInput
            .removeAttr('aria-describedby')
            .removeAttr('aria-invalid');
        }
      });
    },

    _setActiveThumbnail: function(imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(
          this.selectors.productImageWraps + ':not(.hide)',
          this.$container
        ).data('image-id');
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)',
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(this.classes.activeClass)
        .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');

      $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initProductSlider: function() {
      var self = this,
        options = {
        dots: false,
        arrows: true,
        infinite: false,
        //centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable:true,
        vertical: false,
        verticalSwiping: false
      };

      setTimeout(function(el) {
        //document.addEventListener('lazybeforeunveil', function(e){
          var imobj = document.querySelectorAll(self.selectors.productFeaturedImage);
          imobj&& $.each(imobj, function(e,t){
            e>0&&t.classList.remove('img-hide');
          });
          $(el).slick(options);
       // });
      }, 500, this.selectors.productSlider);
    },

    _destroyProductSlider: function() {
      $(this.selectors.productSlider).slick('unslick');
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = slate.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = slate.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _toggleDesc: function() {
      var dec = document.querySelectorAll('.toggle-dec');
      for (var i = 0; i < dec.length; i++) {
        dec[i].addEventListener('click', function(e) {
          e.preventDefault();
          var $pd = $('.prod-dec');
          $pd.toggleClass('show-less');
          if($pd.hasClass('show-less')) {
            this.innerText = 'More';
          } else {
            this.innerText = 'Less';
          }
        });
      }
    },

    _zoomImage:function(){
      $(".zoom-img").each(function(){
        $(this).zoom({
          on:'click',
          url: $(this).data('zoom'),
          magnify: 0.8,
          touch: false,
          onZoomIn: function() {
            $(this).addClass('image-is-zoomed');
          },
          onZoomOut: function() {
            $(this).removeClass('image-is-zoomed');
          }
        });
      });
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCart).removeClass("disable");
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCart).addClass("disable");
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCart).addClass("disable");
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          slate.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          slate.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          slate.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    _videoPlyr: function() {
      const player = new Plyr('#player-mobile-hide', {
      autoplay: true,
      muted: true
      });
      const player1 = new Plyr('#player-desktop-hide', {
      autoplay: true,
      muted: true
      });
    },

    _owlCarousel: function(){
      if($(".data-slick-slider").length){
        options = {
            dots: true,
            nav: true,
            items: 3,
            loop: true,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 2
                },
                680: {
                    items: 2
                },
                1024: {
                    items: 4
                }
            }
        };
        setTimeout(function(el) {
          $(el).owlCarousel(options);
        }, 1000, ".data-slick-slider");

      }else{
        setTimeout(this._owlCarousel,200);
      }

      if($(".mobile-slider").length){
        options1 = {
            dots: false,
            nav: true,
            loop: true,
            items: 1
        };
        setTimeout(function(el) {
          $(el).owlCarousel(options1);
        }, 1000, ".mobile-slider");

      }else{
        setTimeout(this._owlCarousel,200);
      }

    },

    _setColorName: function() {
      $(".swatch-opt-color span.swatch").html($(".swatch-opt-color .swatch-element").attr("data-value"));
      $(".swatch-opt-color .swatch-element label").click(function(){
        $(".swatch-opt-color span.swatch").html($(this).parent().attr("data-value"));
      });

      var colorDiv = ($('.swatch-opt-color')).detach();
      ($('.swatch-opt-size')).before(colorDiv);
      $(".product-top-detail .no-gutters").show();

    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  return Product;
})();

/**
 * Product list page Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product listing page.
 *
   * @namespace filters
 */

theme.Filters = {};
theme.Filters = (function() {
  console.log("This is thesgingggg");
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  var constants = {
    SORT_BY: 'sort_by'
  };

  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy'
  };

  var data = {
    sortBy: 'data-default-sortby'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this._initBreakpoints();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function() {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function() {
          self._resizeSelect(self.$selects);
        }
      });
    },

    _onSortChange: function() {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, '');
      var queryStringValue = slate.utils.getParameterByName('q');
      var query = queryStringValue !== null ? queryStringValue : '';

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, '');
        query = query !== '' ? '?q=' + query + '&' : '?';

        window.location.href =
          urlStripped + query + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _onFilterChange: function() {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search + selectors.mainContent;
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.$sortSelect.attr(data.sortBy);
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

/*!
 * smoothState.js is jQuery plugin that progressively enhances
 * page loads to behave more like a single-page application.
 *
 * @author  Miguel Ángel Pérez   reachme@miguel-perez.com
 * @see     http://smoothstate.com
 *
 */
!function(t){"use strict";"object"==typeof module&&"object"==typeof module.exports?t(require("jquery"),window,document):t(jQuery,window,document)}(function(t,e,n,o){"use strict";if(!e.history.pushState)return t.fn.smoothState=function(){return this},void(t.fn.smoothState.options={});if(!t.fn.smoothState){var r=t("html, body"),a=e.console,i={debug:!1,anchors:"a",hrefRegex:"",forms:"form",allowFormCaching:!1,repeatDelay:500,blacklist:".no-smoothState",prefetch:!1,prefetchOn:"mouseover touchstart",prefetchBlacklist:".no-prefetch",locationHeader:"X-SmoothState-Location",cacheLength:0,loadingClass:"is-loading",scroll:!0,alterRequest:function(t){return t},alterChangeState:function(t,e,n){return t},onBefore:function(t,e){},onStart:{duration:0,render:function(t){}},onProgress:{duration:0,render:function(t){}},onReady:{duration:0,render:function(t,e){t.html(e)}},onAfter:function(t,e){}},s={isExternal:function(t){var n=t.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);return"string"==typeof n[1]&&n[1].length>0&&n[1].toLowerCase()!==e.location.protocol?!0:"string"==typeof n[2]&&n[2].length>0&&n[2].replace(new RegExp(":("+{"http:":80,"https:":443}[e.location.protocol]+")?$"),"")!==e.location.host},stripHash:function(t){return t.replace(/#.*/,"")},isHash:function(t,n){n=n||e.location.href;var o=t.indexOf("#")>-1,r=s.stripHash(t)===s.stripHash(n);return o&&r},translate:function(e){var n={dataType:"html",type:"GET"};return e="string"==typeof e?t.extend({},n,{url:e}):t.extend({},n,e)},shouldLoadAnchor:function(t,e,n){var r=t.prop("href");return!(s.isExternal(r)||s.isHash(r)||t.is(e)||t.prop("target")||typeof n!==o&&""!==n&&-1===t.prop("href").search(n))},clearIfOverCapacity:function(t,e){return Object.keys||(Object.keys=function(t){var e,n=[];for(e in t)Object.prototype.hasOwnProperty.call(t,e)&&n.push(e);return n}),Object.keys(t).length>e&&(t={}),t},storePageIn:function(e,n,o,r,a,i){var s=t("<html></html>").append(t(o));return"undefined"==typeof a&&(a={}),"undefined"==typeof i&&(i=n),e[n]={status:"loaded",title:s.find("title").first().text(),html:s.find("#"+r),doc:o,state:a,destUrl:i},e},triggerAllAnimationEndEvent:function(e,n){n=" "+n||"";var o=0,r="animationstart webkitAnimationStart oanimationstart MSAnimationStart",a="animationend webkitAnimationEnd oanimationend MSAnimationEnd",i="allanimationend",l=function(n){t(n.delegateTarget).is(e)&&(n.stopPropagation(),o++)},u=function(n){t(n.delegateTarget).is(e)&&(n.stopPropagation(),o--,0===o&&e.trigger(i))};e.on(r,l),e.on(a,u),e.on("allanimationend"+n,function(){o=0,s.redraw(e)})},redraw:function(t){t.height()}},l=function(n){if(null!==n.state){var o=e.location.href,r=t("#"+n.state.id),a=r.data("smoothState"),i=a.href!==o&&!s.isHash(o,a.href),l=n.state!==a.cache[a.href].state;(i||l)&&(l&&a.clear(a.href),a.load(o,!1))}},u=function(i,l){var u=t(i),c=u.prop("id"),f=null,d=!1,h={},p={},g=e.location.href,m=function(t){t=t||!1,t&&h.hasOwnProperty(t)?delete h[t]:h={},u.data("smoothState").cache=h},y=function(e,n){n=n||t.noop;var o=s.translate(e);if(h=s.clearIfOverCapacity(h,l.cacheLength),!h.hasOwnProperty(o.url)||"undefined"!=typeof o.data){h[o.url]={status:"fetching"};var r=t.ajax(o);r.done(function(t){s.storePageIn(h,o.url,t,c),u.data("smoothState").cache=h}),r.fail(function(){h[o.url].status="error"}),l.locationHeader&&r.always(function(t,e,n){var r=t.statusCode?t:n,a=r.getResponseHeader(l.locationHeader);a&&(h[o.url].destUrl=a)}),n&&r.always(n)}},v=function(){if(f){var e=t(f,u);if(e.length){var n=e.offset().top;r.scrollTop(n)}f=null}},S=function(o){var i="#"+c,s=h[o]?t(h[o].html.html()):null;s.length?(n.title=h[o].title,u.data("smoothState").href=o,l.loadingClass&&r.removeClass(l.loadingClass),l.onReady.render(u,s),u.one("ss.onReadyEnd",function(){d=!1,l.onAfter(u,s),l.scroll&&v(),O(u)}),e.setTimeout(function(){u.trigger("ss.onReadyEnd")},l.onReady.duration)):!s&&l.debug&&a?a.warn("No element with an id of "+i+" in response from "+o+" in "+h):e.location=o},w=function(t,n,o){var i=s.translate(t);"undefined"==typeof n&&(n=!0),"undefined"==typeof o&&(o=!0);var f=!1,d=!1,g={loaded:function(){var t=f?"ss.onProgressEnd":"ss.onStartEnd";if(d&&f?d&&S(i.url):u.one(t,function(){S(i.url),o||m(i.url)}),n){var r=h[i.url].destUrl;p=l.alterChangeState({id:c},h[i.url].title,r),h[i.url].state=p,e.history.pushState(p,h[i.url].title,r)}d&&!o&&m(i.url)},fetching:function(){f||(f=!0,u.one("ss.onStartEnd",function(){l.loadingClass&&r.addClass(l.loadingClass),l.onProgress.render(u),e.setTimeout(function(){u.trigger("ss.onProgressEnd"),d=!0},l.onProgress.duration)})),e.setTimeout(function(){h.hasOwnProperty(i.url)&&g[h[i.url].status]()},10)},error:function(){l.debug&&a?a.log("There was an error loading: "+i.url):e.location=i.url}};h.hasOwnProperty(i.url)||y(i),l.onStart.render(u),e.setTimeout(function(){l.scroll&&r.scrollTop(0),u.trigger("ss.onStartEnd")},l.onStart.duration),g[h[i.url].status]()},E=function(e){var n,o=t(e.currentTarget);s.shouldLoadAnchor(o,l.blacklist,l.hrefRegex)&&!d&&(e.stopPropagation(),n=s.translate(o.prop("href")),n=l.alterRequest(n),y(n))},b=function(e){var n=t(e.currentTarget);if(!e.metaKey&&!e.ctrlKey&&s.shouldLoadAnchor(n,l.blacklist,l.hrefRegex)&&(e.stopPropagation(),e.preventDefault(),!T())){A();var o=s.translate(n.prop("href"));d=!0,f=n.prop("hash"),o=l.alterRequest(o),l.onBefore(n,u),w(o)}},C=function(e){var n=t(e.currentTarget);if(!n.is(l.blacklist)&&(e.preventDefault(),e.stopPropagation(),!T())){A();var r={url:n.prop("action"),data:n.serialize(),type:n.prop("method")};d=!0,r=l.alterRequest(r),"get"===r.type.toLowerCase()&&(r.url=r.url+"?"+r.data),l.onBefore(n,u),w(r,o,l.allowFormCaching)}},P=0,T=function(){var t=null===l.repeatDelay,e=parseInt(Date.now())>P;return!(t||e)},A=function(){P=parseInt(Date.now())+parseInt(l.repeatDelay)},O=function(t){l.anchors&&l.prefetch&&t.find(l.anchors).not(l.prefetchBlacklist).on(l.prefetchOn,null,E)},R=function(t){l.anchors&&(t.on("click",l.anchors,b),O(t)),l.forms&&t.on("submit",l.forms,C)},x=function(){var t=u.prop("class");u.removeClass(t),s.redraw(u),u.addClass(t)};return l=t.extend({},t.fn.smoothState.options,l),null===e.history.state?(p=l.alterChangeState({id:c},n.title,g),e.history.replaceState(p,n.title,g)):p={},s.storePageIn(h,g,n.documentElement.outerHTML,c,p),s.triggerAllAnimationEndEvent(u,"ss.onStartEnd ss.onProgressEnd ss.onEndEnd"),R(u),{href:g,cache:h,clear:m,load:w,fetch:y,restartCSSAnimations:x}},c=function(e){return this.each(function(){var n=this.tagName.toLowerCase();this.id&&"body"!==n&&"html"!==n&&!t.data(this,"smoothState")?t.data(this,"smoothState",new u(this,e)):!this.id&&a?a.warn("Every smoothState container needs an id but the following one does not have one:",this):"body"!==n&&"html"!==n||!a||a.warn("The smoothstate container cannot be the "+this.tagName+" tag")})};e.onpopstate=l,t.smoothStateUtility=s,t.fn.smoothState=c,t.fn.smoothState.options=i}});
$(function(){
  'use strict';
  var $page = $('#multipage-section-multipage-customer-service'),
      options = {
        debug: true,
        prefetch: true,
        cacheLength: 4,
        blacklist: 'form',
        anchors: '.multipage-nav li a, .mobile-accordian ul li a',
        onStart: {
          duration: 350, // Duration of our animation
          render: function ($container) {
            // Add your CSS animation reversing class
            $container.addClass('is-exiting');
            // Restart your animation
            smoothState.restartCSSAnimations();
          }
        },
        onReady: {
          duration: 0,
          render: function ($container, $newContent) {
            // Remove your CSS animation reversing class
            $container.removeClass('is-exiting');
            // Inject the new content
            $container.html($newContent);
            //custom function to add content in mobile as accordian
            if ($(window).width() <= 767) {
              mobileAccordian();
            }
          }
        },
        onBefore: function($currentTarget, $container) {
          if ($(window).width() <= 767) {
            $("#content-multipage-customer-service").hide();
            if($($currentTarget).hasClass("active")) {
              $page.toggleClass("close-accordian");
            }
            else {
              $(".mobile-accordian ul li a.active").css("color", "#a2a098");
              $page.removeClass("close-accordian");
            }
          }
        }
      },
      smoothState = $page.smoothState(options).data('smoothState');
});

//custom script to add content in mobile as accordian
function mobileAccordian(){
  if($(".template-page").length){
    var swapData = $("#content-multipage-customer-service").detach();
    if($(".mobile-accordian ul li a").hasClass("active")){
      var swapTo = $(".mobile-accordian ul li a.active").parent();
      $(swapTo).append(swapData);
    }
  }
}
if ($(window).width() <= 767) {
  mobileAccordian();
}

theme.CustomerTemplatePages = {};
theme.CustomerTemplatePages = (function() {

    $('.return').click(function(e) {
      $('.return-block').removeClass('d-none');
      $('.order-dtl').hide();
    });
    $('.return-block .back-btn').click(function(e) {
      $('.return-block').addClass('d-none');
      $('.order-dtl').show();
    });
    $('.chk-box-pro').click(function(e) {
      var chkId = (this.id).match(/\d+/);
      if($(this).prop("checked") == true){
        var tdhtml = '<select id="ContactFormReason" class="form-control" name="contact[Reason For Item'+chkId+']"><option>Does not fit</option><option>Bad quality</option><option>Late delivery</option></select>';
        this.parentNode.parentNode.parentNode.appendChild(document.createElement('td')).innerHTML=tdhtml;
      }
      else if($(this).prop("checked") == false){
        $(this.parentNode.parentNode.parentNode).find('td:last-child').remove();
      }
    });

    var constants = {
        SORT_BY: 'sort_by'
    };
    var selectors = {
        navLinks: '.customer-account-nav .nav-item a',
        contentBlock: '#content-'
    };

    function CustomerTemplatePages(container) {
        this.settings = {
            mediaQueryMediumUp: 'screen and (min-width: 750px)',
            mediaQuerySmall: 'screen and (max-width: 749px)'
        };
        var $container = (this.$container = $(container));
        this.sectionId = $container.attr('data-section-id');
        this.$navLinks = $(selectors.navLinks, $container);
        self = this;
        self._initAccordian();
        self._customerAddresses();
    }
    CustomerTemplatePages.prototype = $.extend({}, CustomerTemplatePages.prototype, {
        _initAccordian: function() {
            var self = this,
                data = [],
                sel = selectors.contentBlock+this.sectionId,
                nlinks = document.querySelectorAll(selectors.navLinks);

            nlinks&&$.each(nlinks, function(i, t) {
              self._setActiveCls();
              var id = t.getAttribute('data-id'),
              title = t.getAttribute('data-title'),
              url = t.getAttribute('data-attr'),
              isActive = t.classList.contains('active');


              if (!isActive) {
                var pgUrl = window.location.pathname,
                key = window.location.search;
              }

              if (id == 'contact-us' || id == 'stockists') {
                return 1;
              }

              if ($( window ).width() > 768) {
                t.addEventListener('click', function(e) {
                  history.pushState({}, title, url);
                });
              }

              var pbody = self._ajaxCall(url, sel);
              data.push(self._createCard(isActive, id, title, pbody));
            });
            document.querySelector(sel).innerHTML = data.join("");
        },
        _gup: function( name, url ) {
          if (!url) url = location.href;
          name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
          var regexS = "[\\?&]"+name+"=([^&#]*)";
          var regex = new RegExp( regexS );
          var results = regex.exec( url );
          return results == null ? null : results[1];
        },
        _setActiveCls: function() {
          var pgUrl = window.location.pathname.split('/'),
          key = window.location.search, cls = '';
          if(!key.length) {
            cls = pgUrl[pgUrl.length - 1 ],
            el = document.querySelector('.'+cls);
            if (el) {
              el.classList.add('active');
            } else {
              document.querySelector('.profile').classList.add('active');
            }

          } else {
            cls = self._gup('view', window.location.href);
            if (cls) {
              console.log(cls);
              el = document.querySelector('.'+cls);
              el&&el.classList.add('active');
            }
          }
        },
        _createCard: function(i, id, title, body) {
            var card = '', act = (i==1)?' show active': '', s = (i==1)?' show': '';
            if ($( window ).width() < 768) {
            act = '', s = '';
            }
            card += '<div id="pane-' + id + '" class="card tab-pane fade' + act + '" role="tabpanel" aria-labelledby="tab-' + id + '">';
            card += '<div class="card-header" role="tab" id="heading-' + id + '">';
            card += '<h5 class="mb-0">';
            card += '<a class="collapsed" data-toggle="collapse' + s + '" href="#collapse-' + id + '" aria-expanded="false" aria-controls="collapse-' + id + '">' + title + '</a>';
            card += '</h5>';
            card += '</div>';
            card += '<div id="collapse-' + id + '" class="collapse" data-parent="#content-'+ this.sectionId +'" role="tabpanel" aria-labelledby="heading-' + id + '">';
            card += '<div class="card-body">';
            card += '<div class="content-block">';
            //card += '<h3>' + title + '</h3>';
            card += body;
            card += '</div>';
            card += '</div>';
            card += '</div>';
            card += '</div>';
            return card;
        },
        _ajaxCall: function(url, id) {
            var body = '';
            $.ajax({
                url: url,
                async: false,
                success: function(res) {
                  var $obj = $(res).find('#content-customer-account');
                  body = $obj[0].innerHTML
                }
            });
            return body;
        },
        _customerAddresses: function() {
          var $newAddressForm = $('#AddressNewForm');
          if (!$newAddressForm.length) {
            return;
          }

          // Initialize observers on address selectors, defined in shopify_common.js
          if (Shopify) {
            new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
              hideElement: 'AddressProvinceContainerNew'
            });
          }

          // Initialize each edit form's country/province selector
          $('.address-country-option').each(function() {
            var formId = $(this).data('form-id');
            var countrySelector = 'AddressCountry_' + formId;
            var provinceSelector = 'AddressProvince_' + formId;
            var containerSelector = 'AddressProvinceContainer_' + formId;

            new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
              hideElement: containerSelector
            });
          });

          // Toggle new/edit address forms
          $(document).on('click','.address-new-toggle', function() {
            document.querySelector('#AddressNewForm').classList.toggle('hide')
            //$newAddressForm.toggle('hide');
          });

          $(document).on('click','.address-edit-toggle', function() {
            var formId = $(this).data('form-id'), el = '#EditAddress_' + formId;
            document.querySelector(el).classList.toggle('hide')
            //$('#EditAddress_' + formId).toggle('hide');
          });

          $(document).on('click','.address-delete', function() {
            var $el = $(this);
            var formId = $el.data('form-id');
            var confirmMessage = $el.data('confirm-message');
            if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          });
          //add logout in customer account mobile accordian
          if ($( window ).width() < 768) {
            var logoutUrl = window.location.origin+'/account/logout';
            var appendLogout = "<a class='a-effect mobile-logout' href='"+logoutUrl+"' >Logout</a>";
            $("#content-customer-account").append(appendLogout);
          }
        },
        onUnload: function() {}
    });
    return CustomerTemplatePages;
})();
//////////////
/*
theme.customerAddresses = {};
theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');
  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(document).on('click','.address-new-toggle', function() {
    document.querySelector('#AddressNewForm').classList.toggle('hide')
    //$newAddressForm.toggle('hide');
  });

  $(document).on('click','.address-edit-toggle', function() {
    var formId = $(this).data('form-id'), el = '#EditAddress_' + formId;
    document.querySelector(el).classList.toggle('hide')
    //$('#EditAddress_' + formId).toggle('hide');
  });

  $(document).on('click','.address-delete', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();
*/


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');
  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  /*$(document).on('click','.address-new-toggle', function() {
    document.querySelector('#AddressNewForm').classList.toggle('hide')
    //$newAddressForm.toggle('hide');
  });*/

  /*$(document).on('click','.address-edit-toggle', function() {
    var formId = $(this).data('form-id'), el = '#EditAddress_' + formId;
    document.querySelector(el).classList.toggle('hide')
    //$('#EditAddress_' + formId).toggle('hide');
  });*/

  /*$(document).on('click','.address-delete', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });*/
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm1').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

var SLOVERS = SLOVERS || {};
$(function(){

  // USE STRICT
  "use strict";
  var log;
  log = function(value) {
    if (typeof console !== "undefined") {
      return console.log(value);
    }
  };
  SLOVERS.initialize = {

    init: function(){
      SLOVERS.initialize.stickyHeader();
      SLOVERS.initialize.hideLogoOnScroll();
      SLOVERS.initialize.navBg();
      SLOVERS.initialize.mobileMenu();
      //SLOVERS.initialize.backToTop();
      SLOVERS.initialize.searchBoxToggle();
      SLOVERS.initialize.miniCartToggle();
      SLOVERS.initialize.newsletterBottom();
      SLOVERS.initialize.homeproductSlick();
      SLOVERS.initialize.headermenuHover();
      //SLOVERS.initialize.moveIt();
      SLOVERS.initialize.filtetoggle();
      SLOVERS.initialize.closeOverlay();
      SLOVERS.initialize.autosearch();
      SLOVERS.initialize.fancyDropdown();
      SLOVERS.initialize.customDropdown();
      SLOVERS.initialize.NavigationUpdatePhil();
      SLOVERS.initialize.breadCrumb();
    },

    // autocomplete search box
    autosearch: function() {
      var pdata = new Bloodhound({
        datumTokenizer: function(Obj) {
          return Bloodhound.tokenizers.whitespace([Obj.title+' ' + Obj.handle]);
        },
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: '/pages/product-json'
      });
      $('.search .typeahead').typeahead(
        {
          hint: false
        },
        {
          searchOnFocus: true,
          display: ["title"],
          // templates: {
          //   empty: [
          //     '<div class="empty-message">',
          //       'unable to find any Best Picture winners that match the current query',
          //     '</div>'
          //   ].join('\n'),
          //   suggestion: '<div><strong>{{title}}</strong> – {{handle}}</div>'
          // },
          //template: '<span>' + '<span class="name">{{title}}</span>' + '</span>',
          href: '/products/{{handle}}',
          source: pdata,
/*          templates: {
            empty: function(context){
               $(".tt-dataset").text('Sorry, no products match your search. Try again.');
                }
          },*/
          debug: false
      });
    },

    breadCrumb: function() {
      var pageURL = $(location).attr("href");
      var myString = pageURL.replace("https://rusthebrand.myshopify.com",'');
      var el = document.querySelectorAll(".desktop-nav .navigation .dropdown a");
      el&&$.each(el, function(i,t) {
        var url = t.getAttribute("href");
        if(url == myString) {

           if(t.classList.contains('parent')) {
           }
           else {
             //console.log("fffffffffffff");
             //console.log(t.parentNode.parentNode.parentNode.parentNode);
            $(".breadcrumb ul li:eq(0)").after('<li><a href="'+ t.getAttribute("data-parent-url") +'">' + t.getAttribute("data-parent-title")+'</a></li>');
           }
        }
      });
    },

    /* custom select dropdown start */
    customDropdown: function() {
      console.log("Wow");
      if($(".custom-select").length) {
        var x, i, j, selElmnt, a, b, c;
        /*look for any elements with the class "custom-select":*/
        x = document.getElementsByClassName("custom-select");
        for (i = 0; i < x.length; i++) {
          selElmnt = x[i].getElementsByTagName("select")[0];
          /*for each element, create a new DIV that will act as the selected item:*/
          a = document.createElement("DIV");
          a.setAttribute("class", "select-selected");
          a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
          x[i].appendChild(a);
          /*for each element, create a new DIV that will contain the option list:*/
          b = document.createElement("DIV");
          b.setAttribute("class", "select-items select-hide");
          for (j = 1; j < selElmnt.length; j++) {
            /*for each option in the original select element,
            create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function(e) {
                /*when an item is clicked, update the original select box,
                and the selected item:*/
                var y, i, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                h = this.parentNode.previousSibling;
                for (i = 0; i < s.length; i++) {
                  if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    if($(".custom-select").attr("id")!="custom-select-sortby"){
                      h.innerHTML = this.innerHTML;
                    }
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    for (k = 0; k < y.length; k++) {
                      y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");

                    if($(".custom-select").attr("id")=="custom-select-sortby"){
                      var sort = s.options[i].value;
                      var collectionPath = $(".custom-select").attr("data-colurl");
                      if(collectionPath == ""){
                        collectionPath = "/collections/all";
                      }
                      var collectionUrl = window.location.origin + collectionPath ;

                      window.location.href = collectionUrl + "?sort_by=" + s.options[i].value ;
                    }

                    break;
                  }
                }
                h.click();
            });
            b.appendChild(c);
          }
          x[i].appendChild(b);
          a.addEventListener("click", function(e) {
              /*when the select box is clicked, close any other select boxes,
              and open/close the current select box:*/
              e.stopPropagation();
              closeAllSelect(this);
              this.nextSibling.classList.toggle("select-hide");
              this.classList.toggle("select-arrow-active");
            });
        }
        function closeAllSelect(elmnt) {
          /*a function that will close all select boxes in the document,
          except the current select box:*/
          var x, y, i, arrNo = [];
          x = document.getElementsByClassName("select-items");
          y = document.getElementsByClassName("select-selected");
          for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
              arrNo.push(i)
            } else {
              y[i].classList.remove("select-arrow-active");
            }
          }
          for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
              x[i].classList.add("select-hide");
            }
          }
        }
      }
    },

    fancyDropdown: function() {
      // fancy select
      $('.fancySelect').fancySelect();
    },

    hideLogoOnScroll: function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 5) {
        $(".site-header").addClass("white-header");
        $(".logo").addClass("show");
        $(".landing-logo").fadeOut(200);
      } else {
        $(".site-header").removeClass("white-header");
        $(".logo").removeClass("show");
        $(".landing-logo").fadeIn(200);
      }
    },

    closeOverlay: function() {
      var ov = document.querySelector('.overlay'),
      mm = document.querySelector('#nav-icon'),
      sh = document.querySelector('.site-header');
      ov&&ov.addEventListener('click', function(e) {
        e.preventDefault();
        var str = ov.getAttribute('data-target'),
        tg = '.'+str.replace(/o-/, ""),
        el = document.querySelectorAll(tg);
        this.classList.remove('active');
        this.classList.remove(tg);
        this.classList.remove(str);
        el&&$.each(el, function(i,t){
          t.classList.remove('active');
        });
        sh&&(sh.classList.contains('search-open'))?sh.classList.remove('search-open'):'';
        sh&&(sh.classList.contains('header-open'))?sh.classList.remove('header-open'):'';
        mm&&(mm.classList.contains('animate-icon'))?mm.classList.remove('animate-icon'):'';
      });
    },
    moveIt: function() {
      var productCursorContainerSelector= '.product-single__photo';
      $(document).on('mouseenter', productCursorContainerSelector,
        function(b){
          var pEl = document.querySelector('#' + b.currentTarget.getAttribute('id')).closest('.pd-img'),
          el = pEl.querySelector('.custom-cursor');
          SLOVERS.initialize.processProductCursorTargetPosition(b);
          _.delay(function(){
            el.classList.add("visible");
            _.delay(function(){
              el.classList.add("moving");
            },0)
          },100)
        }
      );

      $(document).on('mousemove', productCursorContainerSelector, function(b) {
        SLOVERS.initialize.processProductCursorTargetPosition(b)
      });

      $(document).on('mouseleave', productCursorContainerSelector,
        function(a){
          var pEl = document.querySelector('#' + a.currentTarget.getAttribute('id')).closest('.pd-img'),
          el = pEl.querySelector('.custom-cursor');
          el.classList.remove("moving");
          el.classList.add("hidden");
          _.delay(function(){
            el.classList.remove("visible");
            el.classList.remove("hidden");
          },100)
        }
      );
    },

    processProductCursorTargetPosition: function(a) {
      var b = {
        width: 30,
        height: 35
      },
      b = _.extend(b, $(a.currentTarget).offset());
      var pEl = document.querySelector('#' + a.currentTarget.getAttribute('id')).closest('.pd-img'),
      el = pEl.querySelector('.custom-cursor');
      el.style.top = a.pageY - b.top - b.height + 'px';
      el.style.left = a.pageX - b.left - b.width + 'px';
    },

    searchBoxToggle: function() {
      $('.search-toggle-js, .close-search').click(function(e) {
        e.preventDefault();
        $("header").toggleClass("header-open");
        theme.Custom.drawertoggle('.el-search');
      });
      // Mobile version
      $('.search-toggle-mob-js').click(function(e) {
        e.preventDefault();
        $("#nav-icon").trigger("click");
        theme.Custom.drawertoggle('.el-search');
      });
    },

    miniCartToggle: function() {
      $('.bag, .close-cart').click(function(e) {
        e.preventDefault();
        theme.Custom.drawertoggle('.mini-cart');
      });
/*      $('.bag').on('click',function(){
        $(this).trigger('click');
      });*/
/*      $('.mini-cart-slide').on('mouseleave',function(){
        $('.overlay').trigger('click');
      });*/

    },
    homeproductSlick: function () {
      jQuery('.home-products-js').slick({
         infinite: true,
         speed: 1000,
         arrows: true,
         slidesToShow: 4,
         slidesToScroll: 4,
         autoplay: true,
         responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    },

    newsletterBottom: function() {
      if($(".newsletter-js").length > 0) {
         $("html, body").animate({ scrollTop: $(document).height()-30 }, 500);
      }
    },

    filtetoggle: function() {
      $('.filter-btn, .close-filter').click(function(e) {
        e.preventDefault();
        theme.Custom.drawertoggle('.filters');
      });
    },


    stickyHeader: function() {
      $('.site-header').scrollToFixed({
        preFixed: function() {  $("body").removeClass("notify-bar-body"); },
        postFixed: function() { $("body").addClass("notify-bar-body"); }
      });

    },

    blogLoading: function() {
      // Ajax Pagination auto load.
      var pInfScrLoading = false;
      var pInfScrDelay = 250;
      function pInfScrExecute() {
        var pInfScrNode = $('.more').last();
        console.log(pInfScrNode);
        var pInfScrURL = $('.more a').last().attr("href");
        if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
          $.ajax({
            type: 'GET',
            url: pInfScrURL,
            beforeSend: function() {
              pInfScrLoading = true;
              pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"//cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
              pInfScrNode.hide();
            },
            success: function(data) {
              // remove loading feedback
              pInfScrNode.next().remove();
              pInfScrNode.remove();
              $('body,html').stop(true);
              var filteredData = $(data).find(".ajax-blog");
              var filteredMoreData = $(data).find(".more");
              filteredData.insertBefore( $("#product-list-foot") );
              filteredMoreData.insertAfter( $("#product-list-foot") );
              pInfScrLoading = false;
              attachClickEvent();
            },
            dataType: "html"
          });
        }
      }
      function attachClickEvent(){
        /*setTimeout(function() {
          SLOVERS.initialize.sameHeight();
        }, 5000);*/
        $('.more a').click(function(event){
          pInfScrExecute();
          event.stopPropagation();
          return false;
        });
        return false;
      }
      function autoScrollItem(event){
          pInfScrExecute();
          event.stopPropagation();
          return false;
      }
      attachClickEvent();
      if ($body.hasClass('template-blog')){
        $(window).on('scroll', $.debounce(250, function() {
          if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
            var pInfScrNode = $('.more').last();
            if (typeof pInfScrNode != 'undefined' && pInfScrNode) {
              $('.more a').last().trigger("click").remove();
            }
          }
        }));
      }
    },

    navBg: function () {
      var dd = document.querySelectorAll('.dropdown-nav'),
      ddb = document.querySelectorAll('.mobile-nav .dropbtn'),
      sh = document.querySelector('.site-header');
      for (var i = 0; i < dd.length; i++) {
        dd[i].addEventListener('mouseenter', function (event) {
          $('.site-header').addClass("nav-open");
        });

        dd[i].addEventListener('mouseleave', function (event) {
          $('.site-header').removeClass("nav-open");
        });
      }
      for (var i = 0; i < ddb.length; i++) {
        ddb[i].addEventListener('click', function (event) {
          event.preventDefault();
          var sel = '#' + this.getAttribute("data-child"),
          el = document.querySelector(sel);
          $('.dropdown-content').removeClass('show');
          if (el.classList.contains('show')) {
            var sh = document.querySelector('.site-header');
            sh&&sh.classList.remove('nav-open');
          } else {
            el.classList.add('show');
            var sh = document.querySelector('.site-header');
            sh&&sh.classList.add('nav-open');
          }
        });
      }
    },

    headermenuHover: function() {
      if($(window).width >= 991){
        $(".dropdown").mouseenter(function() {
          $(this).addClass("li-hover");
          $(".navigation").addClass("nav-hover");
        });
        $(".dropdown").mouseleave(function() {
          $(this).removeClass("li-hover");
          $(".navigation").removeClass("nav-hover");
        });
      }
     },

    menu: function() {
      var dd = document.querySelectorAll('.dropdown-toggle');
      for (var i = 0; i < dd.length; i++) {
        dd[i].addEventListener('click', function (event) {
          event.preventDefault();
          var sel = '#' + this.getAttribute("data-child"),
          el = document.querySelector(sel);
          if (el.classList.contains('show')) {
            SLOVERS.initialize.closeMenu();
            var sh = document.querySelector('.site-header');
            sh&&sh.classList.remove('active');
          } else {
            var sh = document.querySelector('.site-header');
            sh&&sh.classList.add('active');
            SLOVERS.initialize.openMenu(sel);
          }
        });
      }

      var bdy = document.querySelector('body');
      bdy.addEventListener('click', function (e) {
        if (!$(e.target).is('.dropdown-menu') && !$(e.target).is('.nav-link')) {
          SLOVERS.initialize.closeMenu();
          var sh = document.querySelector('.site-header');
          sh&&sh.classList.remove('active');
        }
      });
    },

    closeMenu: function() {
      var dm = document.querySelectorAll('.dropdown-menu');
      $.each(dm, function(e, t) {
        t.parentNode.classList.remove('show');
        t.classList.remove('show');
      });
    },

    openMenu: function(e) {
      SLOVERS.initialize.closeMenu();
      var el = document.querySelector(e);
      el.parentNode.classList.add('show');
      el.classList.add('show');
      var sh = document.querySelector('.site-header');

        var mtop = sh.offsetHeight - sh.offsetHeight / 2;
        document.querySelector('.dropdown-menu.show').style['margin'] = '0';
        document.querySelector('.dropdown-menu.show').style['top'] = mtop + 'px';

    },

    NavigationUpdatePhil: function() {
      //NAV Links
      var navHoverIn = function(){$( '.dropdown' ).addClass('hoveroff'); $( this ).removeClass('hoveroff');}
      var navHoverOut = function(){$( '.dropdown' ).removeClass('hoveroff');}
      $('.dropdown').hover( navHoverIn, navHoverOut );
    },

    mobileMenu: function() {
      var mm = document.querySelector('#nav-icon');
      mm && mm.addEventListener('click', function (event) {
        event.preventDefault();
        this.classList.toggle('animate-icon');
        theme.Custom.drawertoggle('.slide-nav');
      });
      // $(document).on('click', '.dropbtn', function(e) {
      //   e.preventDefault();
      // })

      $(".slide-nav .navigation li.parentli").click(function() {
        var outer = $(this).attr('class');
        $(".slide-nav .dropdown-menu").each(function() {
          var inner = $(this).parent().attr('class');
        if (outer != inner) {
            $(this).hide();
            $(this).parent().removeClass("active-mobile-menu");
         }
        });
        if($(this).hasClass("active-mobile-menu")){
          $($(this).find(".dropdown-menu")).hide();
        }
        else {
          $($(this).find(".dropdown-menu")).show();
        }
        $(this).toggleClass("active-mobile-menu");
      });
    },

    toggleBackToTop: function() {
      var scroll = $(window).scrollTop(),
      limit = document.querySelector('.site-header').offsetHeight,
      el = document.querySelector('.back-top');

      if (document.body.scrollTop > limit || document.documentElement.scrollTop > limit) {
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    },

    backToTop: function(){
      var el = document.querySelector('.back-top');
      el && el.addEventListener('click', function (event) {
        event.preventDefault();
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    },
    newSlider: function() {
      if (!$('.lookbook-horizontal.swiper-container')) {
        return;
      }
        var t = new Swiper(".lookbook-horizontal.swiper-container", {
            "direction": "horizontal",
            "loop": !1,
            "slidesPerView": "auto",
            "spaceBetween": 0,
            "parallax": !0,
            "freeMode": !0,
            "freeModeSticky": !1,
            "freeModeMomentum": !0,
            "preventInteractionOnTransition": !0,
            "draggable": !0,
            "mousewheel": {
                "enabled": !0,
                "releaseOnEdges": !0
            },
            "autoplay": !1,
            "sensitivity": 1,
            "keyboard": {
                "enabled": !0
            },
            "watchSlidesVisibility": !0,
            "preloadImages": !0,
            "updateOnImagesReady": !0
        });
        $(".swiper-gallery").imagesLoaded().always(function(e) {}).done(function(e) {
            setTimeout(function() {
                t.update(), t.updateSize(), t.updateSlides()
            }, 500)
        })
    }

  };

  SLOVERS.widget = {
    init: function() {
      SLOVERS.widget.revisitPopup();
      SLOVERS.widget.newsletterPopup();
    },
    revisitPopup: function() {
      //console.log('revisit');
    },
    newsletterPopup: function() {
      var checkContentOverflow, closeDialog, eventListeners, fillPopupDialog, fillSizeChartDialog, getCustomClasses, closeMeIcon, getImage, getNewsletter, getPageContent, getSocialIcons, getWrapper, centerPopUP, hideMask, ieCenter, isExpired, mask, maskIsActive, modal, modal_clazz, openDialog, passesExpiration, resetExpiration, showMask, storeExpiration;
      modal = null;
      mask = $('.popup-modal-mask');
      storeExpiration = function() {
        var date, expires, object, seconds_from_now;
        date = new Date();
        seconds_from_now = 1000 * 60 * 60 * 24 * popup_config.days_until;
        expires = date.setTime(date.getTime() + seconds_from_now);
        object = {
          expires: expires
        };
        localStorage.removeItem('GREENFELL_pageclick');
        return localStorage[popup_config.storage_key] = JSON.stringify(object);
      };
      resetExpiration = function() {
        console.log("expireddd");
        localStorage.removeItem(popup_config.storage_key);
        localStorage.removeItem('GREENFELL_pageclick');
        return storeExpiration();
      };
      isExpired = function() {
        if (typeof localStorage[popup_config.storage_key] === "undefined") {
          return false;
        }
        var expires, now, object;
        object = JSON.parse(localStorage[popup_config.storage_key]);
        expires = object.expires;
        now = new Date().getTime();
        if (parseFloat(expires - now) <= 0) {
          console.log("expiressss111");
          resetExpiration();
          return true;
        }
        return false;
      };
      passesExpiration = function() {
        var passed, ObjClickCount;
        passed = false;
        if (Storage === "undefined" || popup_config.days_until === "test_mode") {
          passed = true;
        } else if (typeof localStorage[popup_config.storage_key] === "undefined") {
          passed = true;
          storeExpiration();
        } else {
          passed = isExpired();
        }
        return passed;
      };
      maskIsActive = function() {
        return $('.popup-modal').is(':visible') || $('.modal-mask').length > 0 && $('.modal-mask').is(':visible');
      };
      showMask = function() {
        mask.show();
        return $('body').addClass("modal-on body-fade");
      };
      hideMask = function() {
        mask.hide();
        return $('body').removeClass("modal-on body-fade");
      };
      closeMeIcon = function() {
        return $('<button class="popup-modal-close newsletter-close">Not now, thanks</button>');
      };
      getImage = function() {
        if (popup_config.show_image_enabled !== true) {
          return "";
        }
        if (popup_config.image_link.length > 0) {
          return $('<div class="imgblock"><a href="' + popup_config.image_link + '"><img src="' + popup_config.show_image_url + '" alt=""></a></div>');
        } else {
          return $('<div class="imgblock">').append("<img src='" + popup_config.show_image_url + "' alt=''>");
        }
      };
      getNewsletter = function() {
        var subscribe_module;
        if (popup_config.newsletter_enabled === false) {
          return "";
        }
        subscribe_module = $("<div id='subscribe_module' class='sign-up-popup'></div>").append($("#mc-embedded-subscribe-form").clone());
        return subscribe_module;
      };
      getSocialIcons = function() {
        if (popup_config.social_icons_enabled === false) {
          return "";
        }
        return $(".social-follow").clone();
      };
      getCustomClasses = function() {
        var class_list;
        class_list = "";
        class_list += popup_config.show_image_enabled === true ? " has-image" : " has-no-image";
        class_list += popup_config.popup_heading.length > 0 ? " has-page-content" : " has-no-page-content";
        class_list += popup_config.newsletter_enabled ? " has-newsletter" : " has-no-newsletter";
        class_list += popup_config.social_icons_enabled ? " has-social-icons" : " has-no-social-icons";
        class_list += " popup-overlay newsletter-modal home-newsletter active";
        return class_list;
      };
      getWrapper = function() {
        return '<dialog class="popup-modal newsletter-popup-modal' + getCustomClasses() + '" id="homepage-newsletter" />';
      };
      centerPopUP = function() {
        return $('<div class="popup-center"/>').append('<div class="newsletter-popup" />');
      };
      getPageContent = function() {
        var popup_heading;
        popup_heading = null;
        if (popup_config.popup_heading.length < 1) {
          return "";
        }
        $.getJSON('/pages/' + popup_config.popup_heading + '.json', function(data, textStatus) {
          return popup_heading = "<div class='page-contents'>" + data.page.body_html + "</div>";
        });
        return popup_heading;
      };
      fillSizeChartDialog = function() {
        var dialog;
        if ($('.popup-modal.size-chart').length < 1) {
          dialog = {
            wrapper: getWrapper()
          };
          $('body').append($(dialog.wrapper).append($('.size-chart')));
        }
        return openDialog();
      };
      fillPopupDialog = function() {
        var dialog, getInnerContent, render;
        dialog = {
          wrapper: getWrapper(),
          image: getImage(),
          newsletter: getNewsletter(),
          social_icons: getSocialIcons(),
          closeMe: closeMeIcon()
        };
        getInnerContent = function() {
          if (popup_config.popup_heading.length < 1 && popup_config.newsletter_enabled === false && popup_config.social_icons_enabled === false) {
            return "";
          }
          return $("<div class='half-col' />").append(dialog.body, dialog.newsletter, dialog.social_icons);
        };
        render = function() {
          $('body').append($(dialog.wrapper).append(dialog.closeMe));
          $('<div class="form-block newsletter-popup-box clearfix"></div></div>').appendTo(".newsletter-modal");
          $('.newsletter-popup-box').append(dialog.image, getInnerContent());
          return openDialog();
        };
        if (popup_config.popup_heading.length > 0) {
          return render();
        } else {
          return render();
        }
      };
      checkContentOverflow = function() {
        return setTimeout((function() {
          if (modal.length > 0 && $('.popup-modal-mask').is(':visible')) {
            return modal.imagesLoaded(function() {
              if (modal.outerHeight() >= $window.height()) {
                return $('body').addClass('modal-unfix');
              } else {
                return $('body').removeClass('modal-unfix');
              }
            });
          }
        }), 0);
      };
      ieCenter = function() {
        return modal.css({
          marginTop: -(modal.outerHeight() * 0.5) + "px",
          marginLeft: -(modal.outerWidth() * 0.5) + "px"
        });
      };
      openDialog = function() {
        console.log('openDialog');
        modal = $('dialog[class*="newsletter-popup-modal"]');
        if ($("html").hasClass("ie9")) {
          ieCenter();
        }
        eventListeners();
        modal.addClass("opened").removeClass("closed");
        checkContentOverflow();
        return showMask();
      };
      eventListeners = function() {
        var removeAnimation;
        removeAnimation = function(event) {
          if (event.originalEvent.animationName === 'modal-close') {
            if (modal_clazz === 'popup') {
              return modal.remove();
            } else {
              return modal.removeClass('closed, completed');
            }
          } else {
            return modal.addClass('completed').removeClass('opened');
          }
        };
        DOC.on('click', '.popup-modal', function(e) {
          e.stopPropagation();
          if (e.target === this) {
            return closeDialog();
          }
        });
        $('.popup-modal-close').click(closeDialog);
        $('.modal-close').click(function(e) {
          e.preventDefault();
          return closeDialog();
        });
        mask.click(closeDialog);
        modal.on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', removeAnimation);
        $window.resize(checkContentOverflow);
        DOC.keydown(function(e) {
          if (modal.hasClass('completed') && e.keyCode === 27) {
            return closeDialog();
          }
        });
        return $('dialog.popup-modal #contact_form').on('submit', function(event) {
          var form;
          form = this;
          modal = $(this).closest('.popup-modal');
          modal.find('.error, .success').remove();
          event.preventDefault();
          if (modal.find('input[type="email"]').val().length === 0) {
            modal.find('.inner').prepend('<p class="error">' + popup_config.newsletter_email_blank + '</p>');
            return false;
          } else {
            modal.find('.inner > *').hide();
            modal.find('.inner').prepend('<p class="success">' + popup_config.newsletter_success_message + '</p>').show();
            setTimeout(function() {
              return form.submit();
            }, 500);
          }
          return false;
        });
      };
      closeDialog = function() {
        modal.addClass('closed').removeClass('completed').removeClass('opened').removeClass("active");
        return hideMask();
      };

      if (typeof popup_config.newsletter_enabled != "undefined" && popup_config.enabled && passesExpiration() && (popup_config.popup_heading.length > 0 || popup_config.newsletter_enabled || popup_config.show_image_enabled || popup_config.social_icons_enabled)) {

        return setTimeout((function() {
          if (!(maskIsActive() === true || $('.popup-modal-mask').length < 1)) {
            return fillPopupDialog();
          }
        }), popup_config.seconds_until * 1000);
      } else {

      }
    }

  };

  SLOVERS.documentOnResize = {
    init: function(){}
  };

  SLOVERS.documentOnReady = {
    init: function(){
      SLOVERS.initialize.init();
      SLOVERS.widget.init();

    }
  };

  SLOVERS.documentOnLoad = {
    init: function(){
    }
  };

  SLOVERS.documentOnScroll = {
    init: function(){
      SLOVERS.initialize.hideLogoOnScroll();
      //SLOVERS.initialize.toggleBackToTop();
    }
  };

  var $window = $(window),
  $body = $('body'),
  DOC = $(document),
  windowWidth = $window.width(),
  windowHeight= $window.height();
  $(document).ready( SLOVERS.documentOnReady.init );
  $window.on('load', SLOVERS.documentOnLoad.init);
  $window.on('scroll', SLOVERS.documentOnScroll.init);
  $window.on('resize', SLOVERS.documentOnResize.init );
});

/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
	var defaults = {
		url: false,
		callback: false,
		target: false,
		duration: 120,
		on: 'mouseover', // other options: grab, click, toggle
		touch: true, // enables a touch fallback
		onZoomIn: false,
		onZoomOut: false,
		magnify: 1
	};

	// Core Zoom Logic, independent of event listeners.
	$.zoom = function(target, source, img, magnify) {
		var targetHeight,
			targetWidth,
			sourceHeight,
			sourceWidth,
			xRatio,
			yRatio,
			offset,
			$target = $(target),
			position = $target.css('position'),
			$source = $(source);

		// The parent element needs positioning so that the zoomed element can be correctly positioned within.
		target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
		target.style.overflow = 'hidden';
		img.style.width = img.style.height = '';

		$(img)
			.addClass('zoomImg')
			.css({
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: 0,
				width: img.width * magnify,
				height: img.height * magnify,
				border: 'none',
				maxWidth: 'none',
				maxHeight: 'none'
			})
			.appendTo(target);

		return {
			init: function() {
				targetWidth = $target.outerWidth();
				targetHeight = $target.outerHeight();

				if (source === target) {
					sourceWidth = targetWidth;
					sourceHeight = targetHeight;
				} else {
					sourceWidth = $source.outerWidth();
					sourceHeight = $source.outerHeight();
				}

				xRatio = (img.width - targetWidth) / sourceWidth;
				yRatio = (img.height - targetHeight) / sourceHeight;

				offset = $source.offset();
			},
			move: function (e) {
				var left = (e.pageX - offset.left),
					top = (e.pageY - offset.top);

				top = Math.max(Math.min(top, sourceHeight), 0);
				left = Math.max(Math.min(left, sourceWidth), 0);

				img.style.left = (left * -xRatio) + 'px';
				img.style.top = (top * -yRatio) + 'px';
			}
		};
	};

	$.fn.zoom = function (options) {
		return this.each(function () {
			var
			settings = $.extend({}, defaults, options || {}),
			//target will display the zoomed image
			target = settings.target && $(settings.target)[0] || this,
			//source will provide zoom location info (thumbnail)
			source = this,
			$source = $(source),
			img = document.createElement('img'),
			$img = $(img),
			mousemove = 'mousemove.zoom',
			clicked = false,
			touched = false;

			// If a url wasn't specified, look for an image element.
			if (!settings.url) {
				var srcElement = source.querySelector('img');
				if (srcElement) {
					settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
				}
				if (!settings.url) {
					return;
				}
			}

			$source.one('zoom.destroy', function(position, overflow){
				$source.off(".zoom");
				target.style.position = position;
				target.style.overflow = overflow;
				img.onload = null;
				$img.remove();
			}.bind(this, target.style.position, target.style.overflow));

			img.onload = function () {
				var zoom = $.zoom(target, source, img, settings.magnify);

				function start(e) {
					zoom.init();
					zoom.move(e);

					// Skip the fade-in for IE8 and lower since it chokes on fading-in
					// and changing position based on mousemovement at the same time.
					$img.stop()
					.fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
				}

				function stop() {
					$img.stop()
					.fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
				}

				// Mouse events
				if (settings.on === 'grab') {
					$source
						.on('mousedown.zoom',
							function (e) {
								if (e.which === 1) {
									$(document).one('mouseup.zoom',
										function () {
											stop();

											$(document).off(mousemove, zoom.move);
										}
									);

									start(e);

									$(document).on(mousemove, zoom.move);

									e.preventDefault();
								}
							}
						);
				} else if (settings.on === 'click') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								// bubble the event up to the document to trigger the unbind.
								return;
							} else {
								clicked = true;
								start(e);
								$(document).on(mousemove, zoom.move);
								$(document).one('click.zoom',
									function () {
										stop();
										clicked = false;
										$(document).off(mousemove, zoom.move);
									}
								);
								return false;
							}
						}
					);
				} else if (settings.on === 'toggle') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								stop();
							} else {
								start(e);
							}
							clicked = !clicked;
						}
					);
				} else if (settings.on === 'mouseover') {
					zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

					$source
						.on('mouseenter.zoom', start)
						.on('mouseleave.zoom', stop)
						.on(mousemove, zoom.move);
				}

				// Touch fallback
				if (settings.touch) {
					$source
						.on('touchstart.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							} else {
								touched = true;
								start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							}
						})
						.on('touchmove.zoom', function (e) {
							e.preventDefault();
							zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
						})
						.on('touchend.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							}
						});
				}

				if ($.isFunction(settings.callback)) {
					settings.callback.call(img);
				}
			};

			img.setAttribute('role', 'presentation');
			img.alt = '';
			img.src = settings.url;
		});
	};

	$.fn.zoom.defaults = defaults;
}(window.jQuery));



$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('WholesalePage', theme.WholesalePage);
  sections.register('collection-template', theme.Filters);
  sections.register('account-template', theme.CustomerTemplatePages);
  $(document).on('cart.ready', function(event, cart) {
   minicartWholesaleTag(cart);
  // minicartgiftcardTag(cart);
  });
  $(document).on('cart.requestComplete', function(event, cart) {
    minicartWholesaleTag(cart);
   // minicartgiftcardTag(cart);
    var bd = document.querySelector('body'),
    bag = document.querySelector('.bag'),
    mc = document.querySelector('.mini-cart'),
    qvp = document.querySelector('.quick-view-popup'),
    qv = document.querySelector('.slvr-qv-close'),
    ov = document.querySelector('.overlay');


    if(!bd.classList.contains('template-cart')) {
      if(cart.item_count > 0) {
        setTimeout(function() {
          mc.classList.add('active'),
          bd.classList.add('drawer-open');
          if (qv && qvp.classList.contains('active')) {
            qv.click();
          }
          if($(window).width() > 786) {
            ov.classList.add('active'),
            ov.setAttribute("data-target", "o-mini-cart");
          }
          //theme.Custom.drawertoggle('.mini-cart');
        }, 50);
      }
    }
    if(cart.item_count == 0) {
      theme.Custom.drawertoggle('.mini-cart');
      mc.classList.remove('active'),
      bd.classList.remove('drawer-open');
        ov.classList.remove('active');
        ov.setAttribute("data-target", "");
    }
    else {
      //$('.item-count').html(cart.item_count);
    }
    bag.innerText = 'Cart ' + "[" + cart.item_count + "]";
  });

  /*
  function minicartgiftcardTag(cart){
   // console.log(cart);
    var total_amount = 0;
    $.each( cart.items, function( key, value ) {
      //console.log(value);
      var product_handle = value.handle;
      var product_quantity = value.quantity;
      var product_id = value.id;
      var tax_value = $('.body').attr("tax-value");	
      var elementProductUrl = "/products/"+product_handle+".js";
      if(value.gift_card == true) {
        total_amount = total_amount + (value["price"] * product_quantity);        
      }
      else {
      value["price"] = value["price"] * tax_value;
      total_amount = total_amount + (value["price"] * product_quantity);
      } 
          
  
    });
    if(total_amount != 0) {
    	cart['total_price'] = total_amount;
    	cart['items_subtotal_price'] = total_amount;
    }
	//console.log(cart);
    return "true";
  }
  */
 
  function minicartWholesaleTag(cart){
    var total_discount = 0;
    var total_amount = 0;
    $.each( cart.items, function( key, value ) {
      
      var product_handle = value.handle;
      var product_quantity = value.quantity;

      var product_id = value.id;
      var elementProductUrl = "/products/"+product_handle+".js";
      
      // Remove tax multiplier from Gift card products
      var tax_value = $('.body').attr("tax-value");	
      var elementProductUrl = "/products/"+product_handle+".js";
      if(value.gift_card == true) {
        total_amount = total_amount + (value["price"] * product_quantity);        
      }
      else {
      value["price"] = value["price"] * tax_value;
      total_amount = total_amount + (value["price"] * product_quantity);
      }          
            
      $.ajax({
          url: elementProductUrl,
          dataType: 'json',
          async: false,
          data: {format: "json"},
          success: function(product) {
          opt = [];
          if($.inArray( "wholesale-only", product.tags )!= -1) {
          	value["wholesale"] = "wholesale";
          }
          else{ 
            value["wholesale"] = ""; 
          }
         // value["price"] = product.price;
        }
      });
      
	
    });
    
    // Remove tax multiplier from Gift card products
    if(total_amount != 0) {
    	cart['total_price'] = total_amount;
    	cart['items_subtotal_price'] = total_amount;
    }
    return "true";
  }

  $( document ).ajaxError(function( event, jqxhr, settings, thrownError ) {
    if (jqxhr.responseJSON && jqxhr.responseJSON.status == 422) {
      var errmsg = jqxhr.responseJSON.description,
      em = document.querySelector('.err-msg');
      if (em) {
        em.textContent = '';
      };
      em.textContent = errmsg;
    }
  });


  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // The Ritual Part I page
  function isInView(elem){
    return $(elem).offset().top - $(window).scrollTop() < $(elem).height() ;
  }
  $(window).scroll(function(){
     if (isInView($('#shopify-section-footer'))){
      $('.sticky-title').addClass('sticky-title-fixed');
     }else{
      $('.sticky-title').removeClass('sticky-title-fixed');
     }
  });
  if ($('.wholesale .wholesale-breadcrumb ul').length) { $(".wholesale .wholesale-breadcrumb ul").append('<li>All</li>');}
  if ($('.wsg-cart-labels-inner').length) { $( "<div class='cart-products-lable'><span>Product</span></div>" ).insertBefore( ".wsg-cart-labels-inner" );}

  if ($('.wsg-proxy-container').length) {
    var myVar = setInterval(myTimer, 500);
    function myTimer() {
      if ($('.wsg-variant-border').length) {
        $( "<div class='multi-products-lable'><span>Products</span></div>" ).insertBefore( "#wsg-spof" );
        $( ".wsg-variant-border" ).wrapInner( '<td colspan="5"><table width="100%" border="0"><tr></tr></table></td>');
        clearInterval(myVar);
      }
      if ($('.wsg-table img').length) {
      $('.wsg-table img').each(function() {
        $(this).attr('src', $(this).attr('src').replace("small", "large"));
        $(this).attr('src', $(this).attr('src').replace("75x", "large"));
      });
     }
    }
  }
 /* quantity -  + */

    $('.qtybox .btnqty').on('click', function(){
        var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
        if($(this).hasClass('qtyplus')) {
          qty++;
        }else {
          if(qty > 1) {
            qty--;
          }
        }
        qty = (isNaN(qty))?1:qty;
        $(this).parent('.qtybox').find('.quantity-input').val(qty);
      }); 

  /* Video auto play in the Mobile version
  if ( $(window).width() < 768) {
    if($(".pdp-video").length > 0 ) {
      var chkReadyState = setInterval(function() {
        if (document.readyState == "complete") {
         clearInterval(chkReadyState);
         document.getElementById("player-desktop-hide").play().catch(function() {
          setTimeout(function(){$(".plyr__control").trigger("click");}, 3000);
          });
        }
      }, 100);
    }
  }
  */


});
